import { Link } from "react-router-dom";
import classA1 from "../assets/classA1.jpg";
import classA2 from "../assets/classA2.jpg";
import classB1 from "../assets/classB1.jpg";
import classB2 from "../assets/classB2.jpg";

const imageMap = {
  classA1,
  classA2,
  classB1,
  classB2,
};

function CardCourse({ course, isAdmin = false }) {
  const courseUrl = isAdmin
    ? `/admin/courses/${course.id}`
    : `/khoa-hoc/${course.slug}`;

  const formattedPrice =
    course.price != null
      ? course.price.toLocaleString("vi-VN") + "đ"
      : "Liên hệ";

  const formattedOriginPrice =
    course.price_origin != null
      ? course.price_origin.toLocaleString("vi-VN") + "đ"
      : null;

  const discountPercent =
    course.price_origin && course.price
      ? Math.round(
          ((course.price_origin - course.price) /
            course.price_origin) *
            100
        )
      : null;

  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition duration-300 overflow-hidden group relative">
      <Link to={courseUrl} className="block h-full">
        <div className="overflow-hidden relative">
          <img
            src={imageMap[course.image] || "/placeholder.jpg"}
            alt={course.title}
            className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
            loading="lazy"
          />

          {discountPercent && (
            <span className="absolute top-2 left-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded">
              -{discountPercent}%
            </span>
          )}
        </div>

        <div className="p-4 flex flex-col justify-between h-[calc(100%-12rem)]">
          <h3 className="text-lg font-semibold text-gray-800 group-hover:text-blue-600 transition mb-1">
            {course.title}
          </h3>

          <p className="text-sm text-gray-600 mb-2 line-clamp-2">
            {course.short_desc || "Chưa có mô tả"}
          </p>

          <div className="flex flex-col">
            {formattedOriginPrice && (
              <span className="text-sm text-gray-400 line-through">
                {formattedOriginPrice}
              </span>
            )}

            <span className="text-red-600 font-bold text-lg">
              {formattedPrice}
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default CardCourse;